import { WidgetInstance } from "mobx-store/stores/customScreens/types";
import { ValidationOptionsKeys } from "screens/addEditCustomScreen/types";
import { ValidationSchema } from "../validation.helper";

export interface Props {
  focusedWidgetData: WidgetInstance;
  focusedWidget: null | string | number;
  handleChangeData: (paramName: string, value: string) => void;
  removeFocusedWidget: () => void;
}

export const gneralWidgetValidation: ValidationSchema =  {
  title: [{
          validation: [ValidationOptionsKeys.REQUIRED],    
  }],
  entityId: [],
  imageURL: [{
      validation: [ValidationOptionsKeys.REQUIRED],
  }],
  params: [],
  redirect: [{
      validation: [ValidationOptionsKeys.REQUIRED],
  }],
}